module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_rec_3.d955a67a.png";